import React, { useState, useEffect, Fragment } from "react";
import Skeleton from "react-loading-skeleton";
import Link from "next/link";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import Utils from "../../utils/Utils";
import Image from "next/image";
import { getDefYear } from "../../constants/main";
const GameCardFallback = () => {
  return (
    <div className="GameCardWrapper">
      <h2 className="text-center">No Games Found</h2>
    </div>
  );
};

const GameCard = ({ data, isLoading = false, fallBack = false, render = undefined, isPaidUser = undefined }) => {
  const year = getDefYear();
  const [mobileView, setMobileView] = useState("");
  const leagueType = "ncaa";
  const card = data;
  const isPayed = isPaidUser;
  return isLoading ? (
    <Skeleton height="200px" />
  ) : fallBack === true ? (
    <GameCardFallback />
  ) : (
    <Fragment>
      <div className="score-center-card-holder pt-2">
        <div className="gameCard" onClick={() => setMobileView(card.id)}>
          {/* <div className="date-holder text-center">
        <div className="date">
          {isToday ? "Today" : dayjs(card.date).format("MMM DD")} at {card.time.replace(":00 ", " ")} EST
        </div>
      </div> */}
          <div className=" p-0" style={!isPayed && index > 0 ? { filter: "blur(8px)" } : null}>
            <div
              className="gameCardHeader d-flex justify-content-between"
              style={{ fontWeight: 700, color: "#6B6C72" }}
            >
              <div>Team 1</div>
              <div>Team 2</div>
            </div>
            <div className="gameCardHeader d-flex justify-content-between" style={{ minHeight: "5.2rem" }}>
              <Link href={`/team/${leagueType}/${year}/${card.Home_Team}`} className="scores-team-name">
                <Image
                  src={`http://shotqualitybets.com/static/media/logos/${card.Home_Team}.png`}
                  alt={`${card.Home_Team}`}
                  height={40}
                  width={40}
                  style={{ marginRight: "5px", height: "2.4rem", width: "auto" }}
                />
                {card.Home_Team}
              </Link>
              <Link href={`/team/${leagueType}/${year}/${card.Away_Team}`} className="scores-team-name">
                <Image
                  src={`http://shotqualitybets.com/static/media/logos/${card.Away_Team}.png`}
                  alt={`${card.Away_Team}`}
                  height={40}
                  width={40}
                  style={{
                    marginLeft: "5px",
                    height: "2.4rem",
                    width: "auto",
                  }}
                />
                {card.Away_Team}
              </Link>
            </div>
            {card?.Percent_won && (
              <>
                <div className="gameProgress">
                  <div
                    className="fillProgress"
                    style={{
                      backgroundColor: card.Percent_won < 50 ? card.Away_Team_Color : card.Home_Team_Score,
                      right: card.Percent_won < 50 ? "0px" : "auto",
                      left: card.Percent_won < 50 ? "auto" : "0px",
                      width: card.Percent_won < 50 ? `${100 - card.Percent_won}%` : `${card.Percent_won}%`,
                    }}
                  >
                    <Image
                      height={24}
                      width={24}
                      src={`http://shotqualitybets.com/static/media/logos/${
                        card.Percent_won < 50 ? card.Away_Team : card.Home_Team
                      }.png`}
                      alt={`${card.Away_Team}`}
                      style={{
                        height: "20px",
                        width: "auto",
                        marginLeft: card.Percent_won < 50 ? "10px" : "auto",
                        marginRight: card.Percent_won < 50 ? "auto" : "10px",
                        position: "absolute",
                        right: card.Percent_won < 50 ? "auto" : "0px",
                        top: "2px",
                      }}
                    />
                  </div>
                </div>
                <div className=" d-flex justify-content-between">
                  <div>
                    {Math.round(card.Percent_won)}%{/* {teamSpread} */}
                  </div>
                  <div>
                    {/* {oppTeamSpread}  */}
                    {Math.round(100 - card.Percent_won)}%
                  </div>
                </div>
              </>
            )}
            {card?.Home_Team_Score && (
              <>
                {/* <div className="row m-0">
                  <div className="col-4 text-left p-0">
                    {card.Home_Team.includes(" ") ? getOnlyCapLetters(card.Home_Team) : card.Home_Team.substring(0, 4)}{" "}
                    {teamProjected > 0 ? "+" + teamProjected : teamProjected}
                  </div>
                  {card?.total && <div className="col-4 text-center p-0">O/U {card?.total}</div>}
                </div> */}
                <div className="row m-0">
                  <div className="col-4 text-left p-0" style={{ fontWeight: 700 }}>
                    {card.Home_Team_Score?.toFixed(1)}
                  </div>
                  <div className="text-center col-4 p-0">
                    Predicted
                    <div className="text-center">{(card.Home_Team_Score + card.Away_Team_Score).toFixed(1)}</div>
                  </div>
                  <div className="col-4 text-right p-0" style={{ fontWeight: 700 }}>
                    {card.Away_Team_Score?.toFixed(1)}
                  </div>
                </div>
              </>
            )}
          </div>
          <div
            className="hover-score-team"
            style={
              mobileView === card.id && window.innerWidth < 820
                ? { display: "flex", justifyContent: "space-evenly" }
                : window.innerWidth >= 820 && mobileView === card.id
                ? { justifyContent: "space-evenly" }
                : { justifyContent: "space-evenly" }
            }
          >
            {isPayed ? (
              <>
                <Link
                  href={`/team/${leagueType}/${year}/${card.Home_Team}`}
                  className="scores-team-name-link"
                  target={"_blank"}
                >
                  {card.Home_Team}
                </Link>
                <Link
                  href={`/team/${leagueType}/${year}/${card.Away_Team}`}
                  className="scores-team-name-link"
                  target={"_blank"}
                >
                  {card.Away_Team}
                </Link>
                <Link
                  href={`/${leagueType}/matchup-output/${card.Home_Team}/${card.Away_Team}/true`}
                  className="scores-team-name-link"
                  target={"_blank"}
                >
                  Game Page
                </Link>
              </>
            ) : // : fromFreeLive ? (
            //   <Link href={`/live?gid=${card?.game_id}`} className="scores-team-name-link">
            //     ScoreCenter
            //   </Link>
            // )
            user ? null : (
              <Link href="/login" className="scores-team-name-link">
                Sign in
              </Link>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default GameCard;
